var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"certificate-of-honor"},_vm._l((_setup.images),function(img,idx){return _c('img',{key:idx,staticClass:"certificate-img",staticStyle:{"min-width":"1500px","max-width":"1900px","width":"100%"},attrs:{"src":img,"alt":'荣誉证书' + (idx + 1)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }